import { useEffect, useRef } from "react";

/* Ambient phone noise — the real-phone stuff. Rare, random, and clearly scams:
   spam texts, wrong numbers that apologise, and the occasional scam-likely call.
   All client-side ambience; nothing persists. Respects the notifications toggle. */

const uuid4hex = () => (crypto.randomUUID ? crypto.randomUUID().replace(/-/g, "") : `${Date.now()}${Math.random()}`.replace(/\D/g, "").padEnd(32, "0").slice(0, 32));

const SCAM_TEXTS = [
  "BORNWOOD POWER: Your electricity will be DISCONNECTED in 30 minutes. Avoid disconnection — pay immediately in gift cards.",
  "FIRST STATE BANK: Unusual login detected. Your account is LOCKED. Verify now at fst8-secure-bank.top",
  "Congratulations citizen #7841! You've WON a 2026 Jagar coupe. Pay the $250 release fee to claim.",
  "BORNWOOD TAX OFFICE: A warrant has been issued for unpaid taxes. Officers are en route. Call 555-0199 NOW.",
  "Your parcel is held at the depot. Pay $3.50 customs release: bw-logistics-pay.cc",
];

const WRONG_NUMBER_PAIRS = [
  [{ body: "mate you still on for the docks tonight? bring the long ones" }, { body: "whoops — wrong number. sorry mate. forget i texted." }],
  [{ body: "mum's asking if you're coming sunday. she's doing the roast" }, { body: "oh god wrong person. sorry!! enjoy your sunday anyway" }],
  [{ body: "the aqueduct tickets came through. 2am. don't be late this time" }, { body: "wrong number. you didn't see anything. have a good night citizen." }],
  [{ body: "did you feed the cat?? he keeps staring at me" }, { body: "SORRY wrong chat. but if you have a cat, feed it." }],
];

const SCAM_CALL_LINES = [
  "…this is the last courtesy call regarding your vehicle's extended warranty…",
  "…we are calling from the Bornwood Revenue Service about a pending legal matter…",
  "…your citizen ID has been used in suspicious activity. Press 1 to speak to an officer…",
  "…congratulations, you've been pre-approved for a dockside timeshare…",
];

const pick = (arr) => arr[Math.floor(Math.random() * arr.length)];

export function makeScamCall() {
  return { id: `scam-${uuid4hex().slice(0, 8)}`, caller_name: "Unknown", caller_pc: null, scam: true, line: pick(SCAM_CALL_LINES) };
}

export function useSpamPhone({ enabled, callBusy, onText, onCall }) {
  const state = useRef({ callBusy, onText, onCall });
  state.current = { callBusy, onText, onCall };

  useEffect(() => {
    if (!enabled) return undefined;
    let alive = true;
    let timer = null;
    const fire = () => {
      if (!alive) return;
      const roll = Math.random();
      if (roll < 0.35 && !state.current.callBusy) {
        state.current.onCall(makeScamCall());
      } else if (roll < 0.72) {
        state.current.onText({ id: uuid4hex(), kind: "scam", body: pick(SCAM_TEXTS) });
      } else {
        const pair = pick(WRONG_NUMBER_PAIRS);
        state.current.onText({ id: uuid4hex(), kind: "wrong", body: pair[0].body });
        setTimeout(() => { if (alive) state.current.onText({ id: uuid4hex(), kind: "wrong", body: pair[1].body }); }, 14000 + Math.random() * 12000);
      }
      timer = setTimeout(fire, 55000 + Math.random() * 70000); // rare — every ~1-2 minutes
    };
    timer = setTimeout(fire, 18000 + Math.random() * 17000); // first one lands early enough to notice
    return () => { alive = false; clearTimeout(timer); };
  }, [enabled]);
}
